import { action } from 'typesafe-actions';
import {
  ILoyaltyRewardsResponse,
  ILoyaltyGoalResponse,
  ILoyaltyHistoryResponse,
  Types,
  ILoyaltyProductResponse,
  ILoyaltyProductSimulateResponse,
  ILoyaltyProductListToSend,
  ILoyaltyWithdrawResponse,
  ILoyaltySendWithdrawResponse,
  ILoyaltySendWithdrawBody
} from './types';
import { AxiosError } from 'axios';

export const loadLoyaltyRewards = (loyaltyCustomers: string[]) =>
  action(Types.LOAD_LOYALTY_REWARDS, { loyaltyCustomers });

export const loadLoyaltyRewardsSuccess = (
  loyaltyRewardsResponse: ILoyaltyRewardsResponse
) => action(Types.LOAD_LOYALTY_REWARDS_SUCCESS, { loyaltyRewardsResponse });

export const loadLoyaltyRewardsFailure = (error: AxiosError) =>
  action(Types.LOAD_LOYALTY_REWARDS_FAILURE, { error });

export const loadLoyaltyGoal = (loyaltyCustomers: string[]) =>
  action(Types.LOAD_LOYALTY_GOAL, { loyaltyCustomers });

export const loadLoyaltyGoalSuccess = (
  loyaltyGoalResponse: ILoyaltyGoalResponse
) => action(Types.LOAD_LOYALTY_GOAL_SUCCESS, { loyaltyGoalResponse });

export const loadLoyaltyGoalFailure = (error: AxiosError) =>
  action(Types.LOAD_LOYALTY_GOAL_FAILURE, { error });

export const loadLoyaltyHistory = (loyaltyCustomers: string[]) =>
  action(Types.LOAD_LOYALTY_HISTORY, { loyaltyCustomers });

export const loadLoyaltyHistorySuccess = (
  loyaltyHistoryResponse: ILoyaltyHistoryResponse
) => action(Types.LOAD_LOYALTY_HISTORY_SUCCESS, { loyaltyHistoryResponse });

export const loadLoyaltyHistoryFailure = (error: AxiosError) =>
  action(Types.LOAD_LOYALTY_HISTORY_FAILURE, { error });

export const loadLoyaltyProduct = (sku: string) =>
  action(Types.LOAD_LOYALTY_PRODUCT, { sku });

export const loadLoyaltyProductSuccess = (
  loyaltyProductResponse: ILoyaltyProductResponse
) => action(Types.LOAD_LOYALTY_PRODUCT_SUCCESS, { loyaltyProductResponse });

export const loadLoyaltyProductFailure = (error: AxiosError) =>
  action(Types.LOAD_LOYALTY_PRODUCT_FAILURE, { error });

export const loadLoyaltyProductSimulate = (
  loyaltyCustomers: string,
  productList: ILoyaltyProductListToSend[]
) =>
  action(Types.LOAD_LOYALTY_PRODUCT_SIMULATE, {
    loyaltyCustomers,
    productList
  });

export const loadLoyaltyProductSimulateSuccess = (
  loyaltyProductSimulateResponse: ILoyaltyProductSimulateResponse
) =>
  action(Types.LOAD_LOYALTY_PRODUCT_SIMULATE_SUCCESS, {
    loyaltyProductSimulateResponse
  });

export const loadLoyaltyProductSimulateFailure = (error: AxiosError) =>
  action(Types.LOAD_LOYALTY_PRODUCT_SIMULATE_FAILURE, { error });

export const loadLoyaltyWithdraw = (loyaltyCustomers: string[]) =>
  action(Types.LOAD_LOYALTY_WITHDRAW, { loyaltyCustomers });

export const loadLoyaltyWithdrawSuccess = (
  loyaltyWithdrawResponse: ILoyaltyWithdrawResponse
) => action(Types.LOAD_LOYALTY_WITHDRAW_SUCCESS, { loyaltyWithdrawResponse });

export const loadLoyaltyWithdrawFailure = (error: AxiosError) =>
  action(Types.LOAD_LOYALTY_WITHDRAW_FAILURE, { error });

export const loadLoyaltySendWithdraw = (
  loyaltyCustomers: string[],
  requestBody: ILoyaltySendWithdrawBody
) =>
  action(Types.LOAD_LOYALTY_SEND_WITHDRAW, {
    loyaltyCustomers,
    requestBody
  });

export const loadLoyaltySendWithdrawSuccess = (
  loyaltySendWithdrawResponse: ILoyaltySendWithdrawResponse
) =>
  action(Types.LOAD_LOYALTY_SEND_WITHDRAW_SUCCESS, {
    loyaltySendWithdrawResponse
  });

export const loadLoyaltySendWithdrawFailure = (error: AxiosError) =>
  action(Types.LOAD_LOYALTY_SEND_WITHDRAW_FAILURE, { error });
